const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelar',
            client_id: '07-tendermint-229',
            connection_id: 'connection-219'
        },
        chain_2: {
            chain_name: 'source',
            client_id: '07-tendermint-17',
            connection_id: 'connection-17'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-160',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kyve',
            client_id: '07-tendermint-3',
            connection_id: 'connection-5'
        },
        chain_2: {
            chain_name: 'source',
            client_id: '07-tendermint-15',
            connection_id: 'connection-16'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                fee_version: 'ics29-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3035',
            connection_id: 'connection-2524'
        },
        chain_2: {
            chain_name: 'source',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-8945',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'planq',
            client_id: '07-tendermint-558',
            connection_id: 'connection-483'
        },
        chain_2: {
            chain_name: 'source',
            client_id: '07-tendermint-10',
            connection_id: 'connection-5'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-61',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
